module.exports = __webpack_public_path__ + "img/1tgjg.a67dbc5c.png";